export const normalize = (value: string) => value.trim().toLowerCase();
